
import { Menu } from 'ant-design-vue';
import { defineComponent, PropType } from 'vue';

import { MenuItem } from '@/constants/menu';

export default defineComponent({
  components: {
    'a-menu-item': Menu.Item,
    'a-sub-menu': Menu.SubMenu,
  },
  props: {
    id: { type: String, required: true },
    icon: { type: Function, default: undefined },
    name: { type: String, required: true },
    children: { type: Array as PropType<MenuItem[]>, default: undefined },
  },
});
